const topics = [
  { name: '顶流塌房', count: '12.8w', size: 'lg' },
  { name: '恋情实锤', count: '9.6w', size: 'sm' },
  { name: '综艺翻车', count: '8.3w', size: 'sm' },
  { name: '网红互撕', count: '15.2w', size: 'lg' },
  { name: '片场路透', count: '6.7w', size: 'sm' },
  { name: '选秀黑幕', count: '11.4w', size: 'sm' },
  { name: '合约纠纷', count: '7.8w', size: 'sm' },
  { name: '隐婚生子', count: '10.1w', size: 'lg' },
  { name: '带货翻车', count: '5.9w', size: 'sm' },
  { name: '娱乐圈税务', count: '13.5w', size: 'sm' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-label tracking-wider text-primary-600 bg-primary-100 px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
            话题广场
          </span>
          <h2 className="font-heading text-[32px] md:text-[40px] text-foreground-950">热议话题</h2>
          <p className="text-sm text-foreground-500 mt-3">全网最热话题标签，看看大家都在讨论什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-[900px] mx-auto">
          {topics.map((topic, i) => (
            <div
              key={i}
              className={`group flex items-center gap-2 rounded-full cursor-pointer transition-all duration-300 ${
                topic.size === 'lg'
                  ? 'bg-foreground-900 text-background-50 px-6 py-3 hover:bg-foreground-800'
                  : 'bg-background-50 border border-background-200/70 text-foreground-800 px-5 py-2.5 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              <span className="text-xs md:text-sm font-medium whitespace-nowrap">#{topic.name}</span>
              <span className={`text-xs whitespace-nowrap ${
                topic.size === 'lg' ? 'text-foreground-300' : 'text-foreground-400'
              }`}>
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}